import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

export default class extends Controller {
  connect() {
    const el = this.element.querySelector('.offcanvas');
    if (!el) return;

    this.#removeStalePanel(el.id);

    this.offcanvas = new bootstrap.Offcanvas(el);
    this.offcanvas.show();

    el.addEventListener('hidden.bs.offcanvas', () => {
      this.offcanvas.dispose();
      this.offcanvas = null;
      this.element.remove();

      // Clean invested param from URL
      const url = new URL(window.location.href);
      url.searchParams.delete('invested');
      history.replaceState({}, '', url.toString());
    }, {once: true});
  }

  disconnect() {
    this.offcanvas?.dispose();
    this.offcanvas = null;
  }

  // A second request for the same panel would mount a duplicate id, and every
  // later turbo stream replacement would then target the hidden one.
  #removeStalePanel(id) {
    if (!id) return;

    document.querySelectorAll(`.offcanvas#${CSS.escape(id)}`).forEach((panel) => {
      if (this.element.contains(panel)) return;

      bootstrap.Offcanvas.getInstance(panel)?.dispose();
      panel.closest('[data-controller~="auto-slide-over"]')?.remove();
      document.querySelectorAll('.offcanvas-backdrop').forEach((backdrop) => backdrop.remove());
    });
  }
}
